/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StartJobRequest
 */
export interface StartJobRequest {
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof StartJobRequest
     */
    variables?: { [key: string]: string | undefined; };
    /**
     * Only required for incoming webhooks
     * @type {string}
     * @memberof StartJobRequest
     */
    secret?: string;
}

export function StartJobRequestFromJSON(json: any): StartJobRequest {
    return StartJobRequestFromJSONTyped(json, false);
}

export function StartJobRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): StartJobRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'variables': !exists(json, 'variables') ? undefined : json['variables'],
        'secret': !exists(json, 'secret') ? undefined : json['secret'],
    };
}

export function StartJobRequestToJSON(value?: StartJobRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'variables': value.variables,
        'secret': value.secret,
    };
}


